module.exports = __webpack_public_path__ + "img/DSCN0277.ef72a844.jpg";